module.exports = __webpack_public_path__ + "static/media/default_avatar.44e72e81.png";